import React from 'react'
import BaseIcon from './BaseIcon'

function Facebook(props) {
  return (
    <BaseIcon {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <path d="M13.667 13.333H11V16h2.667v8h4v-8h2.426l.24-2.667h-2.666v-1.11c0-.638.128-.89.744-.89h1.922V8h-3.205c-2.397 0-3.461 1.056-3.461 3.077v2.256z" fill="currentColor" />
      </g>
    </BaseIcon>
  )
}

Facebook.defaultProps = {
  title: 'Facebook Icon'
}

export default Facebook
